import {useMotionValueEvent, useScroll} from 'framer-motion';
import {useState} from 'react';

const useIsPageScrolled = () => {
    const [isPageScrolled, setIsPageScrolled] = useState(false);

    const {scrollY: pageScrollY} = useScroll();

    useMotionValueEvent(pageScrollY, 'change', latest => {
        setIsPageScrolled(latest > 0);
    });

    return isPageScrolled;
};

export default useIsPageScrolled;
